<div class="bg-white drop-shadow py-4 px-6 rounded text-black my-4">
    <div class="flex justify-between w-64 lg:w-96">
        <div class="px-12 py-2 skeleton rounded"></div>
        <div class="px-8 py-2 skeleton rounded"></div>
    </div>
    <div class="mt-4 py-2 skeleton rounded w-2/4"></div>
</div>

<style>
    @keyframes skeleton-loading {
        0% {
            background-color: hsl(200, 20%, 80%);
        }
        100% {
            background-color: hsl(200, 20%, 95%);
        }
    }

    .skeleton {
        background-color: #7f7f7f;
        animation: skeleton-loading 1s linear infinite alternate;
    }
</style>